(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.endDate = new Date(this.dataset.endDate.replace(' ', 'T')).getTime();
        this.daysContainer = this.querySelector('[data-days-container]');
        this.daysEl = this.querySelector('[data-days]');
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');
        this.timer = null;
      }

      connectedCallback() {
        if (isNaN(this.endDate) || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
          this.style.display = 'none';
          return;
        }

        this.update();
        this.timer = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) {
          clearInterval(this.timer);
        }
      }

      update() {
        const now = new Date().getTime();
        const distance = this.endDate - now;

        if (distance < 0) {
          clearInterval(this.timer);
          this.style.display = 'none';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (this.daysEl) {
            if (days > 0) {
                this.daysEl.textContent = days;
                if (this.daysContainer) this.daysContainer.style.display = 'inline-flex';
            } else {
                if (this.daysContainer) this.daysContainer.style.display = 'none';
            }
        }
        
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
    customElements.define('countdown-timer', CountdownTimer);
  }

  if (!customElements.get('announcement-marquee')) {
    class AnnouncementMarquee extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.announcement-bar__marquee');
        this.track = this.querySelector('.announcement-bar__marquee-track');
        this.group = this.track ? this.track.querySelector('.announcement-bar__marquee-group') : null;
        this.speed = parseFloat(this.dataset.speed) || 40;
        this.onResize = this.debounce(() => {
          if (this.classList.contains('is-ready')) {
            this.updateVars();
          } else {
            this.setup();
          }
        }, 250);

        this.setup();

        if (!this.classList.contains('is-ready')) {
          this.onLoad = () => this.setup();
          window.addEventListener('load', this.onLoad, { once: true });
        }

        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        if (this.onLoad) {
          window.removeEventListener('load', this.onLoad);
        }
      }

      setup() {
        if (this.classList.contains('is-ready') || !this.track || !this.group) return;

        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth || !isFinite(groupWidth)) return;

        const viewportWidth = this.viewport ? this.viewport.getBoundingClientRect().width : 0;
        const needed = viewportWidth * 2 + groupWidth;

        let totalWidth = groupWidth;
        let clones = 0;
        while (totalWidth < needed && clones < 10) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          this.track.appendChild(clone);
          totalWidth += groupWidth;
          clones += 1;
        }

        this.updateVars(groupWidth);
        this.classList.add('is-ready');
      }

      updateVars(groupWidth) {
        if (!this.group) return;
        const width = typeof groupWidth === 'number' ? groupWidth : this.group.getBoundingClientRect().width;
        if (!width || !isFinite(width)) return;

        const speed = this.speed > 0 ? this.speed : 40;
        this.style.setProperty('--marquee-shift', width);
        this.style.setProperty('--marquee-duration', width / speed + 's');
      }

      debounce(fn, wait) {
        let timeout;
        return () => {
          clearTimeout(timeout);
          timeout = setTimeout(fn, wait);
        };
      }
    }
    customElements.define('announcement-marquee', AnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
